"use client";

import React from "react";
import TableSkeleton from "../Loading/TableSkeleton";
import styles from "./TableTemplate.module.scss";

const TableTemplate = ({ headers, data, renderRow, isLoading, path }) => {
  const columnsCount = headers.length;

  return (
    <div className={styles.tablePage}>
      <div className={styles.tableContainer}>
        <div className={styles.dataTable}>
          <div className={styles.headerRow} style={{ gridTemplateColumns: `repeat(${columnsCount}, 1fr)` }}>
            {headers.map((header, index) => (
              <div key={index} className={styles.headerCell}>
                {header}
              </div>
            ))}
          </div>

          <div className={styles.tableBody}>
            {isLoading ? (
              <TableSkeleton rows={10} columns={headers.length} />
            ) : data.length > 0 ? (
              data.map((item, index) => (
                <div
                  key={index}
                  onDoubleClick={() => (window.location.href = `${path}/${item.id}`)}
                  className={styles.row}
                  style={{ gridTemplateColumns: `repeat(${columnsCount}, 1fr)`, cursor: "pointer" }}
                >
                  {renderRow(item)}
                </div>
              ))
            ) : (
              <div className={styles.noDataCell}>Нет данных</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableTemplate;
